(ns common.schema.entities.kyc.options
  (:require [common.util :as cu]))

(def kyc-status-not-started :kyc-status/not-started)
(def kyc-status-missing :kyc-status/missing)
(def kyc-status-valid :kyc-status/valid)
(def kyc-status-expired :kyc-status/expired)
(def kyc-status-valid-with-expired-docs :kyc-status/valid-with-expired-docs)

(def status-options [{:key   kyc-status-not-started
               :label "Not started"}
              {:key   kyc-status-missing
               :label "Missing"}
              {:key   kyc-status-valid
               :label "Valid"}
              {:key   kyc-status-expired
               :label "Expired"}
              {:key   kyc-status-valid-with-expired-docs
               :label "Valid with expired docs"}])

(defn label [status]
  (->> status-options
       (cu/filter-by :key status)
       (first)
       :label))

(def blocking-status-options
  (->> [{:value :blocking-status/calculated
         :label "Use calculated blocking"}
        {:value :blocking-status/blocked
         :label "Blocked"}
        {:value :blocking-status/not-blocked
         :label "Not blocked"}]
       (mapv (fn [{:keys [value] :as opt}]
               (assoc opt :key value)))))

(def blocking-status-label-lookup
  (->> blocking-status-options
       (mapv (fn [{:keys [value label]}]
               [value label]))
       (into {})))

(defn get-blocking-status-label
  [value]
  (get blocking-status-label-lookup value "Unknown"))

(def process-status-template :kyc-process.status/template)
(def process-status-draft :kyc-process.status/draft)
(def process-status-prefilled :kyc-process.status/prefilled)
(def process-status-wip :kyc-process.status/wip)
(def process-status-signatures :kyc-process.status/signatures)
(def process-status-waiting-for-e-sign :kyc-process.status/waiting-for-e-sign)
(def process-status-esign-in-progress :kyc-process.status/esign-in-progress)
(def process-status-submitted :kyc-process.status/submitted)
(def process-status-approved :kyc-process.status/approved)
(def process-status-approved-modified :kyc-process.status/approved-modified)
(def process-status-rejected :kyc-process.status/rejected)

(def process-status-options
  [{:key   process-status-template
    :ord   0.0
    :label "Template"}
   {:key   process-status-draft
    :ord   1.0
    :label "Draft"}
   {:key   process-status-prefilled
    :ord   2.0
    :label "Prefilled"}
   {:key   process-status-wip
    :ord   3.0
    :label "WIP"}
   {:key   process-status-waiting-for-e-sign
    :ord   4.0
    :label "eSign"}
   {:key   process-status-esign-in-progress
    :ord   5.0
    :label "eSign in progress"}
   {:key   process-status-signatures
    :ord   6.0
    :label "Sign"}
   {:key   process-status-submitted
    :ord   7.0
    :label "Under review"}
   {:key   process-status-approved
    :ord   8.0
    :label "Approved"}
   {:key   process-status-approved-modified
    :ord   9.0
    :label "Approved - modified"}
   {:key   process-status-rejected
    :ord   10.0
    :label "Rejected"}])

(defn get-process-status-option
  [status]
  (->> process-status-options
       (cu/filter-by :key status)
       (first)))

(defn next-process-status
  [status]
  (let [current-opt (get-process-status-option status)]
    (->> process-status-options
         (remove (fn [opt]
                   (<= (:ord opt) (:ord current-opt))))
         (sort-by :ord)
         (first))))

(defn process-status-label
  [status]
  (->> process-status-options
       (cu/filter-by :key status)
       (first)
       :label))
